import React from "react";
import { withRouter } from "react-router";
import { Breadcrumbs } from 'dma-ui-kit';

const BreadCrumbWithRouter = ({ history, breadcrumbs }) => (
    <Breadcrumbs navigate={history.push} breadcrumbs={breadcrumbs} />
);

export default withRouter(BreadCrumbWithRouter);